import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { UNDO_COMMAND } from 'lexical'

export const Undo = ({ disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      tooltip="Undo"
      keyHint="Cmd+Z"
      keyHintVisualOnly
      size={size}
      icon="curved-arrow-left"
      disabled={disabled}
      onClick={() => {
        editor.dispatchCommand(UNDO_COMMAND, undefined)
      }}
    />
  )
}
